import type { SWRConfiguration } from "swr";
import { fetcher } from "./fetcher";

/**
 * Default SWR configuration
 */
export const swrConfig: SWRConfiguration = {
  fetcher,
  revalidateIfStale: true,
  errorRetryCount: 2,
  errorRetryInterval: 5000,
  refreshInterval: 0,
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  revalidateOnMount: true,
  refreshWhenHidden: false,
  dedupingInterval: 2000,
};

/**
 * Create a custom SWR configuration by extending default config
 * @param customConfig Custom SWR configuration to override defaults
 * @returns Merged SWR configuration
 */
export const createSwrConfig = (customConfig: Partial<SWRConfiguration>): SWRConfiguration => {
  return { ...swrConfig, ...customConfig };
};

export default swrConfig;
